export default __webpack_public_path__ + "static/media/Zaniewski.38de5185.png";